import { Component } from '@angular/core';
import {MenuController} from '@ionic/angular';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  showSubmenu = false;
  showSubSquadre = false;
  showSubMedia = false;
  showSubAltro= false;

  menuItemHandler(): void {
    this.showSubmenu = !this.showSubmenu;
  }

  menuApriSubSquadre(): void {
    this.showSubSquadre = !this.showSubSquadre;
  }

  menuApriSubMedia(): void {
    this.showSubMedia = !this.showSubMedia;
  }

  menuApriSubAltro(): void {
    this.showSubAltro = !this.showSubAltro;
  }


  constructor(public mioMenu: MenuController) {

  }

  nascondiMenu(){

    this.mioMenu.close('start');
    this.showSubmenu = false;
    this.showSubSquadre = false;
    this.showSubMedia = false;
    this.showSubAltro=false;


  }
}
